import React, { useState, ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import {
    Tabs,
    Tab,
    TextField,
    Button,
    MenuItem,
    Select,
    SelectChangeEvent,
    CardMedia,
    Input,
    Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const AddServiceProvider = () => {
    const navigate = useNavigate();

    const [tabIndex, setTabIndex] = useState(0);
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };

    const [image, setImage] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");

    const [country, setCountry] = useState("default");
    const [state, setState] = useState("default");
    const [city, setCity] = useState("default");

    return (
        <>
            <div className="main_title">
                <h1>Add Service Provider</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/manage-service-providers")}>
                        Manage Service Providers
                    </button>{" "}
                    - Add Service Provider
                </p>
            </div>

            <Box className="custom_tabs1">
                <Tabs value={tabIndex} onChange={handleTabChange} className="custom_tabs_links">
                    <Tab label="General Details" />
                    <Tab label="Documents" />
                    <Tab label="Bank Details" />
                    <Tab label="Commission" />
                </Tabs>
            </Box>

            <div className="cards">
                {/* ================= GENERAL DETAILS ================= */}
                {tabIndex === 0 && (
                    <div className="form">
                        <div className="gap_p">
                            {/* ===== Upload Photo/Logo ===== */}
                            <div className="control_group w_100">
                                <label htmlFor="business-photo">
                                    Photo/Logo of the Business<span className="req">*</span>
                                </label>
                                {image ? (
                                    <div className="upload_image">
                                        <div className="upload_image_holder no_radius">
                                            <figure>
                                                <CardMedia component="img" image={image} alt="photo" />
                                            </figure>
                                            <button 
                                                type="button" 
                                                onClick={() => { setImage(""); setFileName(""); }} 
                                                style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 0 }}
                                                aria-label="Remove uploaded image"
                                            >
                                                <CloseIcon />
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <label className="upload_image" htmlFor="business-photo">
                                        <Input
                                            sx={{ display: "none" }}
                                            id="business-photo"
                                            type="file"
                                            inputProps={{ accept: "image/png,image/jpeg" }}
                                            onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                                const files = event.target.files;
                                                if (files && files[0].type.includes("image")) {
                                                    setFileName(files[0].name);
                                                    setImage(URL.createObjectURL(files[0]));
                                                }
                                            }}
                                        />
                                        <span className="upload_image_holder no_radius">
                                            <figure className="add_img">
                                                <img src="/static/images/placeholder.png" alt="icon" />
                                                <span className="upload_img_icon">
                                                    <img src="/static/images/edit2_icon.svg" alt="icon" />
                                                </span>
                                            </figure>
                                        </span>
                                    </label>
                                )}
                            </div>

                            {/* ===== Owner & Business Name ===== */}
                            <div className="control_group w_50">
                                <label htmlFor="ownerName">Owner Name<span className="req">*</span></label>
                                <TextField id="ownerName" placeholder="Enter Owner Name" fullWidth />
                            </div>
                            <div className="control_group w_50">
                                <label htmlFor="businessName">Business Name<span className="req">*</span></label>
                                <TextField id="businessName" placeholder="Enter Business Name" fullWidth />
                            </div>

                            {/* ===== Phone & Email ===== */}
                            <div className="control_group w_50">
                                <label htmlFor="contactPhone">Contact Phone<span className="req">*</span></label>
                                <PhoneInput
                                    inputProps={{ id: "contactPhone", name: "contactPhone" }}
                                    country={"in"}
                                    placeholder="Enter Contact Phone"
                                    inputStyle={{ width: "100%" }}
                                />
                            </div>
                            <div className="control_group w_50">
                                <label htmlFor="contactEmail">Contact Email<span className="req">*</span></label>
                                <TextField id="contactEmail" placeholder="Enter Contact Email" fullWidth />
                            </div>
                            <div className="control_group w_33">
                                <label htmlFor="pin">Generate temporary password & force reset</label>
                                <TextField
                                    id="pin"
                                    placeholder="Enter passowrd"
                                    fullWidth
                                    hiddenLabel
                                />
                            </div>  
                            {/* ===== Bio ===== */}
                            <div className="control_group w_100">
                                <label htmlFor="bio">Bio<span className="req">*</span></label>
                                <TextField id="bio" placeholder="Enter Business Bio" fullWidth multiline minRows={3} />
                            </div>

                            {/* ===== Operating Hours ===== */}
                            <div className="control_group w_50">
                                <label htmlFor="openingTime">Opening Time<span className="req">*</span></label>
                                <TextField id="openingTime" type="time" fullWidth />
                            </div>
                            <div className="control_group w_50">
                                <label htmlFor="closingTime">Closing Time<span className="req">*</span></label>
                                <TextField id="closingTime" type="time" fullWidth />
                            </div>

                            {/* ===== Address ===== */}
                            <div className="control_group w_50">
                                <label htmlFor="address1">Address Line 1<span className="req">*</span></label>
                                <TextField id="address1" placeholder="Enter Address Line 1" fullWidth />
                            </div>
                            <div className="control_group w_50">
                                <label htmlFor="address2">Address Line 2</label>
                                <TextField id="address2" placeholder="Enter Address Line 2" fullWidth />
                            </div>

                            {/* ===== Location ===== */}
                            <div className="control_group w_25">
                                <label htmlFor="countrySelect">Country<span className="req">*</span></label>
                                <Select id="countrySelect" value={country} onChange={(e) => setCountry(e.target.value)} fullWidth>
                                    <MenuItem disabled value="default">Select Country</MenuItem>
                                    <MenuItem value="india">India</MenuItem>
                                    <MenuItem value="usa">USA</MenuItem>
                                    <MenuItem value="uk">UK</MenuItem>
                                </Select>
                            </div>
                            <div className="control_group w_25">
                                <label htmlFor="stateSelect">State<span className="req">*</span></label>
                                <Select id="stateSelect" value={state} onChange={(e) => setState(e.target.value)} fullWidth>
                                    <MenuItem disabled value="default">Select State</MenuItem>
                                    <MenuItem value="maharashtra">Maharashtra</MenuItem>
                                    <MenuItem value="gujarat">Gujarat</MenuItem>
                                    <MenuItem value="delhi">Delhi</MenuItem>
                                </Select>
                            </div>
                            <div className="control_group w_25">
                                <label htmlFor="citySelect">City<span className="req">*</span></label>
                                <Select id="citySelect" value={city} onChange={(e) => setCity(e.target.value)} fullWidth>
                                    <MenuItem disabled value="default">Select City</MenuItem>
                                    <MenuItem value="mumbai">Mumbai</MenuItem>
                                    <MenuItem value="pune">Pune</MenuItem>
                                    <MenuItem value="ahmedabad">Ahmedabad</MenuItem>
                                </Select>
                            </div>
                            <div className="control_group w_25">
                                <label htmlFor="zipCode">Zip Code<span className="req">*</span></label>
                                <TextField id="zipCode" placeholder="Enter Zip Code" fullWidth />
                            </div>
                        </div>
                        <div className="form_btn mt_30">
                            <Button className="btn btn_primary">Submit</Button>
                        </div>
                    </div>
                )}

                {/* ================= DOCUMENTS ================= */}
                {tabIndex === 1 && (
                    <div className="form">
                        <div className="gap_p">
                            <div className="control_group w_50">
                                <label htmlFor="docName">Document Name<span className="req">*</span></label>
                                <TextField id="docName" placeholder="Enter Name" fullWidth />
                            </div>
                            <div className="control_group w_50">
                                <label htmlFor="expiryDate">Expiry Date<span className="req">*</span></label>
                                <TextField id="expiryDate" type="date" fullWidth />
                            </div>

                            <div className="control_group w_50">
                                <label htmlFor="docFront">Upload Front Side<span className="req">*</span></label>
                                <Input
                                    sx={{ display: "none" }}
                                    id="docFront"
                                    type="file"
                                    inputProps={{ accept: "image/png,image/jpeg" }}
                                />
                                <label htmlFor="docFront" className="upload_image v2">
                                    <span className="upload_image_holder no_radius">
                                        <figure className="add_img">
                                            <img src="/static/images/placeholder.png" alt="icon" />
                                            <span className="upload_img_icon">
                                                <img src="/static/images/edit2_icon.svg" alt="icon" />
                                            </span>
                                        </figure>
                                    </span>
                                </label>
                            </div>

                            <div className="control_group w_50">
                                <label htmlFor="docBack">Upload Back Side<span className="req">*</span></label>
                                <Input
                                    sx={{ display: "none" }}
                                    id="docBack"
                                    type="file"
                                    inputProps={{ accept: "image/png,image/jpeg" }}
                                />
                                <label htmlFor="docBack" className="upload_image v2">
                                    <span className="upload_image_holder no_radius">
                                        <figure className="add_img">
                                            <img src="/static/images/placeholder.png" alt="icon" />
                                            <span className="upload_img_icon">
                                                <img src="/static/images/edit2_icon.svg" alt="icon" />
                                            </span>
                                        </figure>
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div className="form_btn mt_30">
                            <Button className="btn btn_primary">Submit</Button>
                        </div>
                    </div>
                )}

                {/* ================= BANK DETAILS ================= */}
                {tabIndex === 2 && (
                    <div className="form">
                        <div className="gap_p">
                            <div className="control_group w_50">
                                <label htmlFor="bankName">Bank Name<span className="req">*</span></label>
                                <TextField id="bankName" placeholder="Enter Bank Name" fullWidth />
                            </div>
                            <div className="control_group w_50">
                                <label htmlFor="accountHolder">Account Holder’s Name<span className="req">*</span></label>
                                <TextField id="accountHolder" placeholder="Enter Name" fullWidth />
                            </div>
                            <div className="control_group w_50">
                                <label htmlFor="branchName">Branch Name<span className="req">*</span></label>
                                <TextField id="branchName" placeholder="Enter Branch Name" fullWidth />
                            </div>
                            <div className="control_group w_50">
                                <label htmlFor="bankCode">Bank Code<span className="req">*</span></label>
                                <TextField id="bankCode" placeholder="Enter Bank Code" fullWidth />
                            </div>
                        </div>
                        <div className="form_btn mt_30">
                            <Button className="btn btn_primary">Submit</Button>
                        </div>
                    </div>
                )}

                {/* ================= COMMISSION ================= */}
                {tabIndex === 3 && (
                    <div className="form">
                        <div className="gap_p">
                            <div className="control_group w_50">
                                <label htmlFor="commission">Commission Percentage<span className="req">*</span></label>
                                <TextField id="commission" placeholder="Enter Commission" fullWidth />
                            </div>
                        </div>
                        <div className="form_btn mt_30">
                            <Button className="btn btn_primary">Submit</Button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default AddServiceProvider;
